var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.952 14.296h-1.373a.308.308 0 00-.24.113 6.91 6.91 0 01-5.332 2.504 6.89 6.89 0 01-4.895-2.026 6.9 6.9 0 01-1.485-2.197A6.847 6.847 0 013.084 10 6.88 6.88 0 015.112 5.11a6.911 6.911 0 014.894-2.025 6.91 6.91 0 015.332 2.504.31.31 0 00.24.113h1.374c.123 0 .199-.137.13-.24A8.402 8.402 0 009.985 1.6 8.389 8.389 0 001.6 10.085c.047 4.6 3.793 8.312 8.406 8.312 2.971 0 5.58-1.539 7.076-3.861a.156.156 0 00-.13-.24zm1.736-4.42l-2.772-2.188a.156.156 0 00-.254.123v1.485H9.53a.157.157 0 00-.157.156v1.094c0 .086.07.156.157.156h6.133v1.484c0 .131.152.205.253.123l2.772-2.187a.156.156 0 000-.246z",
    fill: "#BFBFBF"
  })));
}

export default __webpack_public_path__ + "./fonts/Logout.f3ee6557d00d2fba6f50fcddc633ed71.svg";
export { SvgLogout as ReactComponent };